export enum CoverageAction {
    Approval = 1,
    Cash = 2
}
